import React, { useEffect, useState } from 'react';
import { object, func } from 'prop-types';
import { ALERT_TYPE, ShowToastMessage, useForm } from '@laramie/ui';
import { DatePickerCustom, Modal, Select } from '../../common';
import { getDateNow } from '../../../utils/convert';

const ProrrogaSeleccionModal = (props) => {

    const [state, setState] = useState({
        periodo: "",
        cuotas: []
    });

    const mount = () => {
        setState({
            periodo: props.data.periodo,
            cuotas: props.data.cuotas
        });
    }
    useEffect(mount, [props]);

    const [disabledProrroga, setDisabledProrroga] = useState({
        vencimiento1: false,
        vencimiento2: false,
    })

    const [ formValues, formHandle, , formSet] = useForm({
        idEmisionEjecucionCuota: 0,
        fechaVencimiento1: null,
        fechaVencimiento1Prorroga: null,
        fechaVencimiento2: null,
        fechaVencimiento2Prorroga: null
    });

    //handles
    const handleClickAceptar = () => {

        const tieneProrroga1 = (formValues.fechaVencimiento1Prorroga && formValues.fechaVencimiento1Prorroga.getTime() > formValues.fechaVencimiento1.getTime());
        const tieneProrroga2 = (formValues.fechaVencimiento2Prorroga && formValues.fechaVencimiento2Prorroga.getTime() > formValues.fechaVencimiento2.getTime());
        if (!tieneProrroga1 && !tieneProrroga2) {
            ShowToastMessage(ALERT_TYPE.ALERT_WARNING, 'Debe definir la prórroga de vencimientos');
            return false;
        }

        const result = {
            idEmisionEjecucionCuota: formValues.idEmisionEjecucionCuota,
            fechaVencimiento1Prorroga: formValues.fechaVencimiento1Prorroga,
            fechaVencimiento2Prorroga: formValues.fechaVencimiento2Prorroga
        }
        props.onConfirm(result);
    };

    const handleClickCancelar = () => {
        props.onDismiss();
    }

    function getMaxDate(date1, date2) {
        if (!date1 && !date2) return null;
        if (date1 && !date2) return date1;
        if (!date1 && date2) return date2;
        if (date1.getTime() > date2.getTime()) return date1;
        else return date2;
    }


    return (
        <>

        <Modal
            size="lg"
            title="Determine el periodo-cuota a prorrogar"
            onEscape={handleClickCancelar}
            body={(
                <div className="row form-basic">
                    <div className="col-12">
                        <label htmlFor="idEmisionEjecucionCuota" className="form-label">Cuota</label>
                        <Select
                            name="idEmisionEjecucionCuota"
                            className="form-control"
                            value={ formValues.idEmisionEjecucionCuota }
                            emptyOption="Sin selección"
                            emptyValue={0}
                            options={state.cuotas.map(item => ({ value: item.id, label: `${state.periodo} / ${item.cuota} - ${item.descripcion}` }))}
                            onChange={({ target }) => {
                                const idEmisionEjecucionCuota = parseInt(target.value);
                                if (idEmisionEjecucionCuota > 0) {
                                    const cuota = state.cuotas.find(f => f.id === idEmisionEjecucionCuota);
                                    formSet({
                                        idEmisionEjecucionCuota: idEmisionEjecucionCuota,
                                        fechaVencimiento1: cuota.fechaVencimiento1,
                                        fechaVencimiento2: cuota.fechaVencimiento2,
                                        fechaVencimiento1Prorroga: null,
                                        fechaVencimiento2Prorroga: null
                                    });
                                    const today = getDateNow();
                                    setDisabledProrroga({
                                        vencimiento1: (cuota.fechaVencimiento1.getTime() < today.getTime()),
                                        vencimiento2: (cuota.fechaVencimiento2.getTime() < today.getTime())
                                    });
                                }
                                else {
                                    formSet({
                                        idEmisionEjecucionCuota: 0,
                                        fechaVencimiento1: null,
                                        fechaVencimiento2: null,
                                        fechaVencimiento1Prorroga: null,
                                        fechaVencimiento2Prorroga: null
                                    });
                                    setDisabledProrroga({
                                        vencimiento1: false,
                                        vencimiento2: false,
                                    });
                                }
                              }}
                        />
                    </div>
                    <div className="col-6">
                        <label htmlFor="fechaVencimiento1" className="form-label">Primer vencimiento actual</label>
                        <DatePickerCustom
                            name="fechaVencimiento1"
                            placeholder=""
                            className="form-control"
                            value={formValues.fechaVencimiento1}
                            disabled={true}
                        />
                    </div>
                    <div className="col-6">
                        {!disabledProrroga.vencimiento1 ?
                        <>
                        <label htmlFor="fechaVencimiento1Prorroga" className="form-label">Primer vencimiento prorrogado</label>
                        <DatePickerCustom
                            name="fechaVencimiento1Prorroga"
                            placeholder=""
                            className="form-control"
                            value={formValues.fechaVencimiento1Prorroga}
                            onChange={formHandle}
                            minValue={formValues.fechaVencimiento1}
                            maxValue={getMaxDate(formValues.fechaVencimiento2, formValues.fechaVencimiento2Prorroga)}
                            disabled={formValues.idEmisionEjecucionCuota === 0}
                        />
                        </>
                        :
                        <label htmlFor="fechaVencimiento1Prorroga" className="form-label m-top-35">La fecha está vencida no admite prórroga</label>
                        }
                    </div>
                    <div className="col-6">
                        <label htmlFor="fechaVencimiento2" className="form-label">Segundo vencimiento actual</label>
                        <DatePickerCustom
                            name="fechaVencimiento2"
                            placeholder=""
                            className="form-control"
                            value={formValues.fechaVencimiento2}
                            disabled={true}
                        />
                    </div>
                    <div className="col-6">
                        {!disabledProrroga.vencimiento2 ?
                        <>
                        <label htmlFor="fechaVencimiento2Prorroga" className="form-label">Segundo vencimiento prorrogado</label>
                        <DatePickerCustom
                            name="fechaVencimiento2Prorroga"
                            placeholder=""
                            className="form-control"
                            value={formValues.fechaVencimiento2Prorroga}
                            onChange={formHandle}
                            minValue={getMaxDate(formValues.fechaVencimiento2, formValues.fechaVencimiento1Prorroga)}
                            disabled={formValues.idEmisionEjecucionCuota === 0}
                        />
                        </>
                        :
                        <label htmlFor="fechaVencimiento2Prorroga" className="form-label m-top-35">La fecha está vencida no admite prórroga</label>
                        }
                    </div>
                </div>
            )}
            footer={(<>
                <button className="btn btn-outline-primary" data-dismiss="modal" onClick={ (event) => handleClickCancelar() }>Cancelar</button>
                <button className="btn btn-primary" data-dismiss="modal" onClick={ (event) => handleClickAceptar() }>Aceptar</button>
            </>)}
        />

        </>
    );
}

ProrrogaSeleccionModal.propTypes = {
    data: object.isRequired,
    onConfirm: func.isRequired,
    onDismiss: func.isRequired,
};

export default ProrrogaSeleccionModal;